function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useEffect, useRef, useState } from "react";
import getId from "get-video-id";
import { buildVideoUrl } from "./buildVideoUrl";
import { twMerge } from "../../../utils";
import { getOrientationFromSize } from "./getOrientationFromSize";
export function VideoFrame(param) {
    var url = param.url, title = param.title, transform = param.transform, className = param.className;
    var containerRef = useRef(null);
    var video = getId(url);
    var videoUrl = buildVideoUrl(video);
    var ref = _slicedToArray(useState("wide"), 2), containerOrientation = ref[0], setContainerOrientation = ref[1];
    useEffect(function() {
        if (containerRef.current && typeof ResizeObserver !== "undefined") {
            var observer = new ResizeObserver(function(entries) {
                if (entries.length) {
                    var ref, ref1;
                    var ref2 = entries[0], contentRect = ref2.contentRect, _contentBoxSize = ref2.contentBoxSize, contentBoxSize = _contentBoxSize === void 0 ? [] : _contentBoxSize;
                    var ref3, ref4;
                    var width = (ref4 = (ref3 = (ref = contentBoxSize[0]) === null || ref === void 0 ? void 0 : ref.inlineSize) !== null && ref3 !== void 0 ? ref3 : contentRect === null || contentRect === void 0 ? void 0 : contentRect.width) !== null && ref4 !== void 0 ? ref4 : 0;
                    var ref5, ref6;
                    var height = (ref6 = (ref5 = (ref1 = contentBoxSize[0]) === null || ref1 === void 0 ? void 0 : ref1.blockSize) !== null && ref5 !== void 0 ? ref5 : contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) !== null && ref6 !== void 0 ? ref6 : 0;
                    if (containerRef.current) {
                        containerRef.current.style.setProperty("--container-width", "".concat(width, "px"));
                        containerRef.current.style.setProperty("--container-height", "".concat(height, "px"));
                        setContainerOrientation(getOrientationFromSize(width, height, 16 / 9));
                    }
                }
            });
            observer.observe(containerRef.current);
            return function() {
                return observer.disconnect();
            };
        }
        return function() {};
    }, [
        containerRef
    ]);
    if (!videoUrl) return null;
    return /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: twMerge("isolate relative overflow-hidden", className),
        style: {
            "--container-width": "0px",
            "--container-height": "0px"
        }
    }, /*#__PURE__*/ React.createElement("iframe", {
        allowFullScreen: true,
        title: title,
        src: transform ? transform(videoUrl, video).toString() : videoUrl.toString(),
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        className: twMerge("absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2", containerOrientation === "wide" && "w-[var(--container-width)] h-[calc(var(--container-width)*0.5626)]", containerOrientation === "narrow" && "h-[var(--container-height)] w-[calc(var(--container-height)*1.7778)]")
    }));
}

//# sourceMappingURL=VideoFrame.js.map